import React from "react";
import { NavLink } from "react-router-dom";
import "./AvatarDropdown.css";

const AvatarDropdown = () => {
  return (
    <div className="avatarDropdownMenu">
      <ul>
        {/* Section 1 */}
        <li>
          <NavLink to="/community-home">Community Home</NavLink>
        </li>
        <li>
          <NavLink to="/community-page">Community Page</NavLink>
        </li>
        <li>
          <NavLink to="/my-room">My Room</NavLink>
        </li>
        <hr />

        {/* Section 2 */}
        <li>
          <NavLink to="/leaderboard">Leaderboard</NavLink>
        </li>
        <li>
          <NavLink to="/games">GAMES</NavLink>
        </li>
        <hr />

        {/* Section 3: Community Rooms */}
        <li className="dropdown-title">COMMUNITY</li>
        <li><a href="/room1">Room 1</a></li>
        <li><a href="/room2">Room 2</a></li>
        <li><a href="/room3">Room 3</a></li>
        <li><a href="/room4">Room 4</a></li>
        <li><a href="/room5">Room 5</a></li>
        <li className="create-room">
          <NavLink to="/create-room">
            <i className="fa fa-plus-circle"></i> Create Room
          </NavLink>
        </li>
        <hr />

        {/* Section 4 */}
        <div className="avatarDropdownMenu-section4">
          <li>
            <NavLink to="/about">About ..... </NavLink>
          </li>
          <li>
            <NavLink to="/advertise">Advertise</NavLink>
          </li>
          <li>
            <NavLink to="/help">Help</NavLink>
          </li>
          <li>
            <NavLink to="/blog">Blog</NavLink>
          </li>
        </div>
      </ul>
    </div>
  );
};

export default AvatarDropdown;
